import { NeedDto, NeedsActionDto } from '@act/shared/data-transfer-objects';
import { needsSelectors } from 'redux/redux';
import NeedDetailHistoryEntry from './NeedHistoryEntry';

interface NeedDetailHistoryProps {
  need: NeedDto;
  detailMode?: boolean;
  editMode?: boolean;
  setEdit?: (action: NeedsActionDto) => void;
  setEditNeed?: (need: NeedDto) => void;
}

const NeedDetailHistory = ({
  need,
  detailMode,
  editMode,
  setEdit,
  setEditNeed,
}: NeedDetailHistoryProps) => {
  const history = needsSelectors.useSelectNeedHistoryEntriesByIds(
    need.historyEntryIds
  );
  return (
    <div className="need-history">
      {history.map(h => (
        <div key={`history-${h.id}`} className="entry">
          <NeedDetailHistoryEntry
            need={need}
            historyEntry={h}
            detailMode={detailMode}
            editMode={editMode}
            setEdit={setEdit}
            setEditNeed={setEditNeed}
          />
        </div>
      ))}
    </div>
  );
};

export default NeedDetailHistory;
